// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.widgets-container {
  display: grid;
  row-gap: 20px;
  column-gap: 20px;
  margin: 20px 0;
  overflow-y: auto;
}
.widgets-container .widget-container {
  border-radius: 10px;
  background-color: white;
  display: grid;
  grid-template-rows: 16px 348px 16px;
  align-items: center;
  padding: 15px;
  height: 380px;
}
.widgets-container .widget-container .widget-title {
  color: #142A31;
  font-size: 12px;
  font-weight: bold;
  width: 100%;
}
.widgets-container .widget-container .widget-report-link {
  color: #40A0C1;
  font-size: 12px;
  font-weight: bold;
  width: 100%;
  display: flex;
  align-items: center;
  column-gap: 6px;
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/pages/Home/Widgets/Widgets.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AACD;AACC;EACC,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,mCAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;AACF;AACE;EACC,cAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;AACH;AAEE;EACC,cAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,eAAA;AAAH","sourcesContent":[".widgets-container {\n\tdisplay: grid;\n\trow-gap: 20px;\n\tcolumn-gap: 20px;\n\tmargin: 20px 0;\n\toverflow-y: auto;\n\n\t.widget-container {\n\t\tborder-radius: 10px;\n\t\tbackground-color: white;\n\t\tdisplay: grid;\n\t\tgrid-template-rows: 16px 348px 16px;\n\t\talign-items: center;\n\t\tpadding: 15px;\n\t\theight: 380px;\n\n\t\t.widget-title {\n\t\t\tcolor: #142A31;\n\t\t\tfont-size: 12px;\n\t\t\tfont-weight: bold;\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t.widget-report-link {\n\t\t\tcolor: #40A0C1;\n\t\t\tfont-size: 12px;\n\t\t\tfont-weight: bold;\n\t\t\twidth: 100%;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tcolumn-gap: 6px;\n\t\t\tuser-select: none;\n\t\t\tcursor: pointer;\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
